module.exports = __webpack_public_path__ + "static/persona-3-9317c63c20d83e35672aeb58f2c00d67.png";